export default "__VITE_ASSET__tqMdyU3o__"